var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map"},[_c('div',{attrs:{"id":_vm.id}},[_c('loader-component',{attrs:{"with_text":true,"text":"Sedang memuat peta"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }